// FNP-973 — READ-ONLY module. There is deliberately no mutations.ts: the
// deployed schema exposes no create/update/delete for a hosted zone, and write
// operations are FNP-977's scope, not this ticket's.

// ⚠️ `nameServers` is deliberately ABSENT from the list selection.
//
// The resolver populates it only on getHostedZone — on listHostedZones it comes
// back null for every row. Selecting it here would put a column of nulls in
// front of an operator and read as "this zone has no delegation set", which is
// false. The detail view fetches the single record to get it. See
// HOSTED_ZONE_DETAIL_FIELDS below.
const HOSTED_ZONE_LIST_FIELDS = `
    id
    name
    recordSetCount
    privateZone
    comment
    accountId
`;

const HOSTED_ZONE_DETAIL_FIELDS = `
    id
    name
    callerReference
    recordSetCount
    privateZone
    comment
    nameServers
    accountId
`;

export const listHostedZones = `
   query listHostedZones($parentDomainName: String, $limit: Int, $nextToken: String) {
       listHostedZones(parentDomainName: $parentDomainName, limit: $limit, nextToken: $nextToken) {
           items {${HOSTED_ZONE_LIST_FIELDS}}
           nextToken
       }
   }
`;

export const getHostedZone = `
   query getHostedZone($id: ID!, $parentDomainName: String) {
       getHostedZone(id: $id, parentDomainName: $parentDomainName) {${HOSTED_ZONE_DETAIL_FIELDS}}
   }
`;
